<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAdmit_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13.156 24c-.367 0-.735-.147-1.016-.442l-5.72-6.007a1.56 1.56 0 0 1 0-2.133c.562-.59 1.47-.59 2.032 0l4.704 4.94L23.548 9.442c.561-.59 1.47-.59 2.031 0a1.56 1.56 0 0 1 0 2.133L14.171 23.557c-.28.295-.647.443-1.015.443"
    />
</svg>
